import { Link } from "react-router-dom";
import { ChevronRight, Loader2 } from "lucide-react";

export function RecentStrip({ items }) {
  if (!items.length) return null;
  return (
    <section className="space-y-3" data-testid="recent-strip">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-semibold tracking-tight text-white">Your latest</h2>
        <Link to="/create/assets" className="flex items-center gap-0.5 text-xs font-medium text-zinc-400 transition-colors hover:text-white" data-testid="recent-strip-assets-link">
          All assets <ChevronRight className="h-3.5 w-3.5" />
        </Link>
      </div>
      <div className="-mx-4 flex gap-2.5 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:px-0">
        {items.slice(0, 10).map((g) => (
          <Link key={g.id} to="/create/assets" className="relative h-24 w-24 shrink-0 overflow-hidden rounded-2xl border border-white/10 bg-ink-850 sm:h-28 sm:w-28" data-testid={`recent-item-${g.id}`}>
            {g.status === "complete" && g.thumb_url && <img src={g.thumb_url} alt={g.prompt} loading="lazy" className="h-full w-full object-cover" />}
            {g.status === "running" && (
              <span className="absolute inset-0 flex flex-col items-center justify-center gap-1 bg-[linear-gradient(110deg,#121216_30%,#202027_50%,#121216_70%)] bg-[length:200%_100%] text-[10px] text-zinc-400 animate-shimmer">
                <Loader2 className="h-4 w-4 animate-spin" /> Creating
              </span>
            )}
            {g.status === "failed" && <span className="absolute inset-0 flex items-center justify-center p-2 text-center text-[10px] text-zinc-500">Failed · no charge</span>}
          </Link>
        ))}
      </div>
    </section>
  );
}
